// import { canUseDOM } from 'exenv';

export function jwNewestVideoLoading(resp = {}, store = {}) {
  return {
    type: 'JW_NEWEST_VIDEO_LOADING',
    jwNewestVideo: resp,
    store
  };
}

export function jwNewestVideoLoaded(resp = {}, store = {}) {
  return {
    type: 'JW_NEWEST_VIDEO_LOADED',
    jwNewestVideo: resp,
    store
  };
}

export function jwNewestVideoLoadError(error, store = {}) {
  return {
    type: 'JW_NEWEST_VIDEO_ERROR',
    jwNewestVideo: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
